import { gql } from '@apollo/client';

export const ALL_SUBURBS = gql`
  query AllSuburbs($input: FilterSuburbInput!) {
    suburbs: getSuburbs(input: $input) {
      id
      name
    }
  }
`;
